import React from 'react';
import ReactDOM from 'react-dom/client';
import './tokens.css';
import './tabler-subset.css';
import { initTheme } from './theme.js';
import App from './App.jsx';
import { preloadRoute } from './routeComponents.js';
import { initAnalytics } from './utils/analytics.js';

// Web-only conversion tracking — inert until IDs are set in env, and never runs
// in the extension (this entry isn't used there). Capturing UTMs early matters.
initAnalytics();
initTheme();

const container = document.getElementById('root');
const tree = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

function mount() {
  // A populated #root means the build prerendered this route (scripts/prerender.mjs),
  // so adopt that markup rather than wiping it and re-rendering from scratch.
  if (container.firstChild) ReactDOM.hydrateRoot(container, tree);
  else ReactDOM.createRoot(container).render(tree);
}

// Resolve this route's code-split chunk BEFORE the first render. Rendering straight
// away would hit App.jsx's React.lazy() boundary and emit a Suspense fallback, which
// cannot match the prerendered markup — React would discard it and the page would
// flash blank. Routes with no chunk (the homepage) resolve on the next microtask.
preloadRoute(window.location.pathname).catch(() => {}).then(mount);
